import UpdateProposalRecordError from "./UpdateProposalRecordError";

export default class InvalidProposalStateTransitionError extends UpdateProposalRecordError {
}
